import type { GuideEntryTarget } from "../../../../../../../api/kehrblatt/learning-guide"
import type { OrganizationNavigationMetadata } from "../../../../../context"

const pageIds: Partial<Record<GuideEntryTarget, string>> = {
  overview: "overview",
  "work-orders": "workOrders",
  notifications: "notifications",
  district: "district",
  properties: "properties",
  customers: "customers",
  users: "users",
  organization: "organization",
  billing: "billing",
}

/** Resolve catalog targets only from this organization's already-authorized page metadata. */
export function resolveLearningEntryDestinations(
  metadata: OrganizationNavigationMetadata | undefined,
  organizationBasePath: string,
): Partial<Record<GuideEntryTarget, string>> {
  if (!metadata?.ready || metadata.basePath !== organizationBasePath) return {}

  const result: Partial<Record<GuideEntryTarget, string>> = {}
  const isLocal = (path: string) => {
    try {
      const url = new URL(path, "https://learning.invalid")
      const decoded = decodeURIComponent(url.pathname)

      return (
        path.startsWith(`${organizationBasePath}/`) &&
        !/[\\\u0000-\u0020]/.test(path) &&
        !decoded.split("/").some((segment) => segment === "." || segment === "..") &&
        url.origin === "https://learning.invalid" &&
        url.pathname.startsWith(`${organizationBasePath}/`) &&
        !url.hash
      )
    } catch {
      return false
    }
  }
  for (const [target, pageId] of Object.entries(pageIds)) {
    const page = metadata.pages.find(
      (candidate) => candidate.id === pageId || candidate.id?.startsWith(`${pageId}:`),
    )
    const path = page?.tabs?.[0]?.path ?? page?.path

    if (path && isLocal(path)) result[target as GuideEntryTarget] = path
  }
  const workOrders = metadata.pages.find((page) => page.id === "workOrders")
  const calendarIndex =
    workOrders?.tabs?.findIndex((tab) => "id" in tab && tab.id === "calendar") ?? -1

  if (workOrders && calendarIndex >= 0) {
    const tab = workOrders.tabs?.[calendarIndex]
    const path = tab?.path ?? `${workOrders.path}?tab=${calendarIndex}`

    if (isLocal(path)) result.calendar = path
  }

  return result
}
